import { register } from '@shopify/theme-sections';
import * as cart from '@shopify/theme-cart';
import ProductVariants from '../components/ProductVariants';
import Swiper from 'swiper/bundle';
import {
  getAllProductsByStyle,
  getProductTags,
} from '../helpers/productStyles';
import {
  htmlDecode,
  waitForElm,
  buildSizes,
  buildCategoryHeading,
} from '../helpers/util';

register('main-product', {
  buildVideo(media) {
    let videoHtml = '',
      iframeClass = '',
      playerHtml;
    if (media.media_type == 'video') {
      playerHtml = `<video playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="none"><source src="${media.sources[0].url}" type="video/mp4"></video>`;
    } else {
      if (media.host == 'vimeo') {
        iframeClass = '-frame js-vimeo-frame';
        playerHtml = `<iframe frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" class="js-vimeo" loading="lazy" src="https://player.vimeo.com/video/${media.external_id}?autopause=0&autoplay=1&amp;background=1&amp;byline=0&amp;controls=0&amp;loop=1&amp;muted=1&amp;playsinline=1&amp;sidedock=0&amp;title=0"></iframe>`;
      } else {
        return videoHtml;
      }
    }
    videoHtml = `<div class="${this.type}__image--item">
      <div class="${this.type}__image--video${iframeClass}">${playerHtml}</div>
      <div class="${this.type}__image--pause-play pause">
        <a href="#" class="pause-video switch-play-pause">
          <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="17.5" r="16.5" fill="white" stroke="black" stroke-width="2"/>
            <path d="M22.2241 10.8621L22.2241 24.1379" stroke="black" stroke-width="2"/>
            <path d="M14.9827 10.8621L14.9827 24.1379" stroke="black" stroke-width="2"/>
          </svg>
        </a>
        <a href="#" class="play-video switch-play-pause">
          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14.5" cy="14.5" r="13.5" fill="white" stroke="black" stroke-width="2"/>
            <path d="M20.875 14.5L12.125 8.25L12.125 20.75L20.875 14.5Z" fill="black"/>
          </svg>
        </a>
      </div>
    </div>`;
    return videoHtml;
  },

  buildWear(products, container) {
    let productsLoaded = 0;
    products.map((product) => {
      if (!Array.isArray(product.tags)) {
        product.tags = product?.tags?.split(', ');
      }
      let htmlItemNode = document.createElement('div');
      htmlItemNode.classList.add('main-product__wear--item', 'product-card');
      htmlItemNode.setAttribute('data-product-id', product.id);
      let imageUrl = this.mainProductItem.buildSrcSet(product.image.src);
      let imageUrlSecondary = this.mainProductItem.buildSrcSet(
        product.images[1].src,
      );
      let priceHtml = '';
      if (product.selected_variant.compare_at_price) {
        priceHtml = `<span class="price-item price-item--sale price-item--sale--with" data-product-price>$${product.selected_variant.price}</span>
          <span class="price-item price-item--regular" data-product-compare>
            $${product.selected_variant.compare_at_price}
          </span>
        </div>`;
      } else {
        priceHtml = `<div class="price__sale">
        <span class="price-item price-item--sale" data-product-price>$${product.selected_variant.price}</span>
        <span class="price-item price-item--regular" data-product-compare></span>
      </div>`;
      }

      let chipHtml = '';

      console.log('product.tags', product.tags);

      product.tags.forEach((tag) => {
        if (tag.includes('chip:')) {
          chipHtml += `<p class="product-card__chip--item">${tag.replace(
            'chip:',
            '',
          )}</p>`;
        }
      });

      let htmlItem = `<div class="product-card__image">
          <a href="/products/${product.handle}" data-product-link>
            <div class="product-card__image--wrapper">
              <img srcset="${imageUrl}" src="${product.image.src}" sizes="165, 360, 533, 720, 940, 1066" alt="${product.title}" loading="lazy" class="motion-reduce main-image" width="3600" height="3600" data-main-image>
              <img srcset="${imageUrlSecondary}" src="${product.images[1].src}" sizes="165, 360, 533, 720, 940, 1066" alt="${product.title}" loading="lazy" class="motion-reduce secondary-image" width="3600" height="3600" data-secondary-image>
            </div>
          </a>
        </div>
        <div class="product-card__content">
          <div class="product-card__title">
            <div class="product-card__title--link">
              <a href="/products/${product.handle}" data-product-link data-product-title>${product.title}</a>
            </div>
          </div>
          <div class="product-card__subtitle"><p>${product.product_type}</p></div>
          <div class="product-card__chip" data-product-chip>${chipHtml}</div>
          <div class="product-card__price ">${priceHtml}</div>
          <div class="product-card__swatches">
            <div class="product-card__swatches--items" data-product-swatches></div>
          </div>
        </div>`;
      htmlItemNode.innerHTML = htmlItem;
      container.appendChild(htmlItemNode);
      productsLoaded++;
      if (productsLoaded == products.length) {
        this.initWearCarousel(container);
      }
    });

    products.map(async (product) => {
      if (!Array.isArray(product.tags)) {
        product.tags = product?.tags?.split(', ');
      }
      let styleTag = getProductTags(product, 'style');
      let currentItemId = product.id;
      if (styleTag.length) {
        product.allProductStyles = await getAllProductsByStyle(styleTag);
      } else {
        product.allProductStyles = false;
      }
      let timespend = 0;
      let wearWait = setInterval(() => {
        timespend = timespend + 2;
        if (product.allProductStyles != undefined) {
          clearInterval(wearWait);
          for (const productIndex in product.allProductStyles.products) {
            let swatchProduct = product.allProductStyles.products[productIndex];
            console.log('swatchProduct', swatchProduct);
            let swatchItem =
              this.mainProductItem.buildSwatchItem(swatchProduct);
            let currentItem = currentItemId == swatchProduct.id ? true : false;
            let itemContainer = container.querySelector(
              `[data-product-id="${product.id}"]`,
            );
            if (swatchItem) {
              if (currentItem) {
                swatchItem.classList.add('selected');
                container
                  .querySelector(
                    `[data-product-id="${product.id}"] [data-product-swatches]`,
                  )
                  .prepend(swatchItem);
              } else {
                container
                  .querySelector(
                    `[data-product-id="${product.id}"] [data-product-swatches]`,
                  )
                  .appendChild(swatchItem);
              }
              swatchItem.addEventListener('click', (e) => {
                e.preventDefault();
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                itemContainer
                  .querySelector('[data-main-image]')
                  .setAttribute('src', swatchProduct.images[0]);
                itemContainer
                  .querySelector('[data-main-image]')
                  .setAttribute(
                    'srcset',
                    this.mainProductItem.buildSrcSet(swatchProduct.images[0]),
                  );
                itemContainer
                  .querySelector('[data-secondary-image]')
                  .setAttribute('src', swatchProduct.images[1]);
                itemContainer
                  .querySelector('[data-secondary-image]')
                  .setAttribute(
                    'srcset',
                    this.mainProductItem.buildSrcSet(swatchProduct.images[1]),
                  );
                let links = itemContainer.querySelectorAll(
                  '[data-product-link]',
                );
                links.forEach((link) => {
                  link.setAttribute('href', swatchProduct.url);
                });
                let chip = itemContainer.querySelector('[data-product-chip]');
                if (chip) {
                  if (swatchProduct?.chip?.length > 0) {
                    chip.style.display = 'flex';
                    let chipHtml = '';
                    swatchProduct?.chip?.forEach((chipItem) => {
                      chipHtml += `<p class="product-card__chip--item">${chipItem}</p>`;
                    });
                    chip.innerHTML = chipHtml;
                  } else {
                    chip.style.display = 'none';
                  }
                }
                let titles = itemContainer.querySelectorAll(
                  '[data-product-title]',
                );

                titles.forEach((title) => {
                  title.textContent = swatchProduct.title;
                });
                let priceSelectors = itemContainer.querySelectorAll(
                  '[data-product-price]',
                );
                let priceSelectorsCompare = itemContainer.querySelectorAll(
                  '[data-product-compare]',
                );
                priceSelectors.forEach((priceSelector) => {
                  priceSelector.textContent = swatchProduct.formattedPrice;
                  priceSelectorsCompare.forEach((priceSelectorCompare) => {
                    if (
                      swatchProduct.formattedCompareAtPrice &&
                      swatchProduct.formattedCompareAtPrice !=
                        swatchProduct.formattedPrice
                    ) {
                      priceSelector.classList.add('sale-price');
                      priceSelectorCompare.textContent =
                        swatchProduct.formattedCompareAtPrice;
                    } else {
                      priceSelector.classList.remove('sale-price');
                      priceSelectorCompare.textContent = '';
                    }
                  });
                });
                itemContainer
                  .querySelector('.selected[data-product-swatch]')
                  .classList.remove('selected');
                e.currentTarget.classList.add('selected');
              });
            }
          }
        } else {
          if (timespend > 5000) {
            clearInterval(wearWait);
          }
        }
      });
    });
  },

  setBenefits() {
    let benefitsContainer = this.mainProductItem.el.querySelector(
      '[data-product-benefits-container]',
    );
    if (!benefitsContainer) return;
    let benefitsItems = this.mainProductItem.buildBenefits(
      this.mainProductItem.benefitTags,
      this.type,
    );
    if (benefitsItems && benefitsItems.length) {
      benefitsItems.forEach((benefitsItem, index) => {
        if (index < 3) {
          benefitsContainer.appendChild(benefitsItem);
        }
      });
      benefitsContainer.parentNode.style.display = 'block';
    }
  },

  setVideoControlsHadle() {
    let pauseNode = this.mainProductItem.el.querySelector(
      `.${this.type}__image--pause-play`,
    );
    if (!pauseNode) return;
    let videoControls = this.mainProductItem.el.querySelectorAll(
      `.${this.type}__image--pause-play a`,
    );
    videoControls.forEach((videoControl) => {
      videoControl.addEventListener('click', (e) => {
        e.preventDefault();
        let videoContainer = e.currentTarget.parentNode.parentNode;
        let buttonContainer = e.currentTarget.parentNode;
        let video = videoContainer.querySelector('video')
          ? videoContainer.querySelector('video')
          : new Vimeo.Player(videoContainer.querySelector('iframe'));
        if (e.currentTarget.classList.contains('pause-video')) {
          video.pause();
          buttonContainer.classList.remove('pause');
          buttonContainer.classList.add('play');
        } else {
          video.play();
          buttonContainer.classList.remove('play');
          buttonContainer.classList.add('pause');
        }
      });
    });
  },

  updatePromoMessage(product) {
    let promoContainerNode = this.mainProductItem.el.querySelector(
      '[data-product-promo-container]',
    );
    if (!promoContainerNode) return;
    if (product.promoMessageLink && product.promoMessageText) {
      promoContainerNode.innerHTML = `<p${
        product.promoMessageTextColor
          ? ` style="color: ${product.promoMessageTextColor}";`
          : ``
      }>${product.promoMessageText} ${
        product.promoMessageUrl
          ? `<a href="${product.promoMessageUrl}"${
              product.promoMessageTextColor
                ? ` style="color: ${product.promoMessageTextColor}";`
                : ``
            }>${product.promoMessageLink}</a>`
          : `${product.promoMessageLink}`
      }</p>`;
      promoContainerNode.style.display = 'block';
    } else {
      promoContainerNode.innerHTML = '';
    }
  },

  updateProductFeatures(product) {
    let featuresContainer = this.mainProductItem.el.querySelector(
      '[data-product-features-container]',
    );
    if (!featuresContainer) return;
    if (product.features) {
      let convertedFeatures = htmlDecode(product.features);
      this.mainProductItem.el.querySelector(
        '[data-product-features-container] .product-details__text',
      ).innerHTML = convertedFeatures;
      featuresContainer.style.display = 'block';
    } else {
      featuresContainer.style.display = 'none';
    }
  },

  updateShippingInfo(product) {
    let shippingContainer = this.mainProductItem.el.querySelector(
      '[data-product-shipping-container] .product-details__text',
    );
    if (!shippingContainer) return;
    if (product.shippingAndReturn) {
      shippingContainer.innerHTML = product.shippingAndReturn;
    } else {
      shippingContainer.innerHTML = shippingContainer.dataset.defaultShipping;
    }
  },

  updateQualityInfo(product) {
    let qualityContainer = this.mainProductItem.el.querySelector(
      '[data-product-quality-container] .product-details__text',
    );
    if (!qualityContainer) return;
    if (product.qualityGuarantee) {
      qualityContainer.innerHTML = product.qualityGuarantee;
    } else {
      qualityContainer.innerHTML = qualityContainer.dataset.defaultQuality;
    }
  },

  updateBenefits(product) {
    let benefitsContainer = this.mainProductItem.el.querySelector(
      '[data-product-benefits-container]',
    );
    if (!benefitsContainer) return;
    let productBenefits = getProductTags(product, 'benefits');
    benefitsContainer.innerHTML = '';
    if (productBenefits.length) {
      let productBenefitsItems = this.mainProductItem.buildBenefits(
        productBenefits,
        this.type,
      );
      if (productBenefitsItems) {
        productBenefitsItems.forEach((productBenefitsItem, index) => {
          if (index < 3) {
            benefitsContainer.appendChild(productBenefitsItem);
          }
        });
        benefitsContainer.parentNode.style.display = 'block';
      }
    } else {
      benefitsContainer.parentNode.style.display = 'none';
    }
  },

  updateImages(product) {
    let imagesContainer = document.querySelector(`.${this.type}__image`);
    let zoomContainer = document.querySelector('[data-zoom-main]');
    let zommThumbContainer = document.querySelector('[data-zoom-thumbnails]');
    let videoIndex = 0;
    imagesContainer.innerHTML = '';
    zoomContainer.innerHTML = '';
    zommThumbContainer.innerHTML = '';
    product.media.forEach((media, index) => {
      if (media.media_type == 'image') {
        let image = `<div class="${this.type}__image--wrap">
          <img src="${media.src}" srcset="${this.mainProductItem.buildSrcSet(
          media.src,
        )}" width="" height="" loading="lazy">
        </div>`;
        let imageHtml = `<div class="${this.type}__image--item">
            <a href="#" data-zoom-index="${++index}">${image}</a>
          </div>`;
        let zoomHtml = `<div class="${this.type}__image--item" data-zoom-index="${index}">${image}</div>`;
        let zoomThumbHtml = `<div class="${this.type}__image--item" data-zoom-thumb data-zoom-index="${index}">${image}</div>`;
        imagesContainer.innerHTML += imageHtml;
        zoomContainer.innerHTML += zoomHtml;
        zommThumbContainer.innerHTML += zoomThumbHtml;
      } else {
        imagesContainer.innerHTML += this.buildVideo(media);
        videoIndex++;
      }
    });
  },

  updateMainInfo(product) {
    let links = this.mainProductItem.el.querySelectorAll('[data-product-link]');
    links.forEach((link) => {
      link.setAttribute('href', product.url);
    });
    let titles = this.mainProductItem.el.querySelectorAll(
      '[data-product-title]',
    );
    let chip = this.mainProductItem.el.querySelector('[data-product-chip]');
    if (chip) {
      if (product.chip.length > 0) {
        chip.style.display = 'flex';
        let chipHtml = '';
        product.chip.forEach((chipItem) => {
          chipHtml += `<p class="${this.type}__chip--item">${chipItem}</p>`;
        });
        chip.innerHTML = chipHtml;
      } else {
        chip.style.display = 'none';
      }
    }
    titles.forEach((title) => {
      title.textContent = product.title;
    });
    let priceSelectors = this.mainProductItem.el.querySelectorAll(
      '[data-product-price]',
    );
    let priceSelectorsCompare = this.mainProductItem.el.querySelectorAll(
      '[data-product-compare]',
    );
    this.mainProductItem.el.querySelector(
      '[data-product-description-container] .product-details__text',
    ).innerHTML = product.description;
    this.mainProductItem.el
      .querySelectorAll('[data-product-selected]')
      .forEach((selectedLabel) => {
        selectedLabel.textContent = '';
      });
    this.mainProductItem.el.querySelector(
      `[data-color-category="${product.colorCategory}"] [data-product-selected]`,
    ).textContent = product.selectedColor;
    priceSelectors.forEach((priceSelector) => {
      priceSelector.textContent = product.formattedPrice;
      priceSelectorsCompare.forEach((priceSelectorCompare) => {
        if (
          product.formattedCompareAtPrice &&
          product.formattedCompareAtPrice != product.formattedPrice
        ) {
          priceSelector.classList.add('sale-price');
          priceSelectorCompare.textContent = product.formattedCompareAtPrice;
        } else {
          priceSelector.classList.remove('sale-price');
          priceSelectorCompare.textContent = '';
        }
      });
    });
  },

  updateKlarna(product) {
    const klarnaEls = document.getElementsByTagName('klarna-placement');
    if (!product && !klarnaEls) return;
    if (klarnaEls.length) {
      klarnaEls.forEach((el) => {
        el.setAttribute('data-purchase-amount', product.price);
      });
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  },

  updateBadges(product) {
    let renderedBadge = this.mainProductItem.buildBadge(product.tags);
    renderedBadge
      ? this.mainProductItem.el
          .querySelector(`.main-product__image--wrap`)
          .appendChild(renderedBadge)
      : null;
  },

  initWearCarousel(el) {
    if (!el) return;

    let html = el.innerHTML;
    let swiperHtml = `<div class='swiper-wrapper'>${html}</div><div class="swiper-button-next swiper-button-next-wear"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" class="icon icon-slide-chevron" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.5L7 6.5L1 12.5" stroke="white"/></svg></div><div class="swiper-button-prev swiper-button-prev-wear"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" class="icon icon-slide-chevron" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.5L7 6.5L1 12.5" stroke="white"/></svg></div>`;
    el.innerHTML = swiperHtml;
    let slides = el.querySelectorAll(`.main-product__wear--item`);
    slides.forEach((slide) => {
      let slideHtml = slide.outerHTML;
      let swiperSlideHtml = `<div class='swiper-slide'>${slideHtml}</div>`;
      slide.outerHTML = swiperSlideHtml;
    });
    const swiper = new Swiper(el, {
      slidesPerView: 1.8,
      spaceBetween: 10,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
      },
    });
    return swiper;
  },

  initCarousel(el) {
    if (!el || window.innerWidth > 992) return;

    let html = el.innerHTML;
    let swiperHtml = `<div class='swiper-wrapper'>${html}</div><div class='swiper-pagination'></div>`;
    el.innerHTML = swiperHtml;
    let slides = el.querySelectorAll(`.${this.type}__image--item`);
    slides.forEach((slide) => {
      let slideHtml = slide.outerHTML;
      let swiperSlideHtml = `<div class='swiper-slide'>${slideHtml}</div>`;
      slide.outerHTML = swiperSlideHtml;
    });
    const swiper = new Swiper(el, {
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
    return swiper;
  },

  closeProductAccordions() {
    let accordion = document.querySelectorAll('.product-details__acc');
    accordion.forEach((detail, closeDetail, details) => {
      detail.ontoggle = (closeDetail) => {
        if (detail.open) {
          details.forEach((detailSingle) => {
            if (detailSingle != detail) {
              detailSingle.open = false;
            }
          });
        }
      };
    });
  },

  stickyBuyButton() {
    let buyButtonWrap = document.querySelector(`.${this.type}__form--wrap`),
      initialButtonPosition;
    let scrollBefore = 0;
    let productBody = document.querySelector('.template-product');
    let hideKey;
    if (window.innerWidth > 992) {
      hideKey = 'top';
    } else {
      hideKey = 'bottom';
    }
    document.addEventListener('scroll', function () {
      if (buyButtonWrap.offsetTop > 90) {
        initialButtonPosition = buyButtonWrap.offsetTop;
      }
      const topOfScreen = window.scrollY;
      if (
        topOfScreen > initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.style[hideKey] = '-100%';
        productBody.classList.remove('header-active');
      }
      if (
        topOfScreen < initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (
        topOfScreen > initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.classList.add('sticky-add');
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (topOfScreen == 0 && buyButtonWrap.classList.contains('sticky-add')) {
        buyButtonWrap.classList.remove('sticky-add');
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (
        buyButtonWrap.classList.contains('sticky-add') &&
        window.innerWidth > 992
      ) {
        if (
          scrollBefore < 2 &&
          !productBody?.classList?.contains('header-active')
        ) {
          scrollBefore = topOfScreen;
          productBody.classList.add('header-active');
          //Desired action
        } else if (
          scrollBefore < topOfScreen &&
          productBody.classList.contains('header-active')
        ) {
          scrollBefore = topOfScreen;
          productBody.classList.remove('header-active');
          //Desired action
        }
      }
      scrollBefore = topOfScreen;
    });
  },

  reviewClickHandle: function () {
    waitForElm('.main-product__reviews .bv_main_container').then(() => {
      let reviewContainers = this.container.querySelectorAll(
        '.main-product__reviews .bv_main_container',
      );
      if (reviewContainers) {
        reviewContainers.forEach((reviewContainer) => {
          reviewContainer.addEventListener('click', (e) => {
            e.preventDefault();
            window.scroll({
              top:
                document
                  .getElementById('BVRRSearchContainer')
                  .getBoundingClientRect().top - 130,
              behavior: 'smooth',
            });
          });
        });
      }
    });
  },

  // 2/13/23 - this block has been commented because we've been requested to remove
  // BazaarVoice but this block of code has some functionality that the client
  // might want to keep. If so, then update accordingly to select the new container
  // Note: data-bv-show is the BazaarVoice container- thats the one that will need to be
  // updated here with the new container to get the scroll functionality working again
  // Reminder: uncomment the call to this function at the bottom
  // scrollToReviews: function () {
  //   const reviewsContainer = document.querySelector(
  //     ".product-reviews .container [data-bv-show='reviews']"
  //   );
  //   const urlParams = window.location.search;

  //   window.onload = () => {
  //     // checking for url param
  //     if (urlParams.includes("scrollToReviews")) {
  //       let retry = 1;

  //       // this will run on an interval until retries expire or element has finished loading
  //       const checkForElementContent = () => {
  //         if (retry < 5) {
  //           // currently, the reviews container has two children so we wait for both to load before scrolling
  //           // Note: if the app changes the structure so there is only one child then this will probably break
  //           if (reviewsContainer.childElementCount > 1) {
  //             stopInterval();
  //             setTimeout(() => {
  //               const reviews = document.querySelector("#reviews");
  //               reviews.scrollIntoView({ behavior: "smooth", block: "start" });
  //             }, 600);
  //           }
  //         } else {
  //           stopInterval();
  //           return "reviews not found";
  //         }

  //         retry++;
  //       };

  //       const interval = setInterval(checkForElementContent, 500);
  //       function stopInterval() {
  //         clearInterval(interval);
  //       }
  //     }
  //   };
  // },

  initMain: function () {
    const mainProduct = this.container.querySelector('[data-main-product]');
    this.mainProductItem = new ProductVariants(mainProduct);
    let currentItemId = mainProduct.dataset.productId;
    let variantsList = mainProduct.querySelector('[data-color-swatches]');
    let timespend = 0;
    let wearContainer = this.mainProductItem.el.querySelector(
      '[data-product-wear]',
    );
    let widgetId = wearContainer?.dataset?.widgetId;
    let rebuyProductsContainer = this.mainProductItem.el.querySelector(
      '[data-wear-products]',
    );
    document.addEventListener('rebuy.ready', (event) => {
      const rebuyWidget = window.Rebuy.widgets.find(
        (widget) => widget.id === widgetId,
      );
      const productsToShow = rebuyWidget.data.products;
      this.buildWear(productsToShow, rebuyProductsContainer);
    });
    let mainProductWait = setInterval(() => {
      timespend = timespend + 2;
      if (this.mainProductItem.allProductStyles != undefined) {
        this.setBenefits();
        buildSizes(
          this.mainProductItem.data,
          this.mainProductItem.data.id,
          'regular',
        );
        this.setVideoControlsHadle();
        clearInterval(mainProductWait);
        if (this.mainProductItem.allProductStyles == false) {
          if (this.mainProductItem.data.options.length > 1) {
            let swatchItem = this.mainProductItem.buildSwatchItem(
              this.mainProductItem.data,
            );
            if (swatchItem) {
              swatchItem.classList.add('selected');
              variantsList.prepend(swatchItem);
            }
          }
          this.mainProductItem.buildOtherSwatches(
            this.mainProductItem.data,
            this.type,
          );
        } else {
          let productCategory = null;
          for (const product in this.mainProductItem.allProductStyles
            .products) {
            let swatchProduct =
              this.mainProductItem.allProductStyles.products[product];
            this.reviewClickHandle();
            let swatchItem =
              this.mainProductItem.buildSwatchItem(swatchProduct);
            if (swatchItem) {
              let currentItem =
                currentItemId == swatchProduct.id ? true : false;
              if (currentItem) {
                swatchItem.classList.add('selected');
                if (
                  this.mainProductItem.colorCategories.length > 1 &&
                  swatchProduct.colorCategory
                ) {
                  if (
                    variantsList.querySelector(
                      `[data-color-category="${swatchProduct.colorCategory}"]`,
                    ) == null
                  ) {
                    buildCategoryHeading(
                      swatchProduct.colorCategory,
                      variantsList,
                    );
                    productCategory = swatchProduct.colorCategory;
                  }
                  variantsList.prepend(swatchItem);
                  swatchItem.parentNode.parentNode.querySelector(
                    `[data-color-category="${swatchItem.dataset.productCategory}"] [data-product-selected]`,
                  ).textContent = swatchItem.parentNode.parentNode.querySelector(
                    '.selected[data-product-swatch]',
                  ).dataset.colorName;
                } else {
                  variantsList.prepend(swatchItem);
                }
                this.mainProductItem.buildOtherSwatches(
                  swatchProduct,
                  this.type,
                );
              } else {
                if (
                  this.mainProductItem.colorCategories.length > 1 &&
                  variantsList.querySelector(
                    `[data-color-category="${swatchProduct.colorCategory}"]`,
                  ) == null
                ) {
                  if (
                    mainProduct.querySelector(
                      '.variants__color > .variants__color--selected',
                    ) != null
                  ) {
                    mainProduct
                      .querySelector(
                        '.variants__color > .variants__color--selected',
                      )
                      .remove();
                    mainProduct.querySelector(
                      '[data-is-categorized]',
                    ).dataset.isCategorized = true;
                  }
                  buildCategoryHeading(
                    swatchProduct.colorCategory,
                    variantsList,
                  );
                  variantsList.appendChild(swatchItem);
                } else {
                  variantsList.appendChild(swatchItem);
                }
              }
              swatchItem.addEventListener(
                'mouseenter',
                () => {
                  if (swatchItem.classList.contains('selected')) {
                    return false;
                  }
                  swatchItem.parentNode.parentNode.querySelector(
                    `[data-color-category="${swatchItem.dataset.productCategory}"] [data-product-selected]`,
                  ).textContent = swatchItem.dataset.colorName;
                },
                false,
              );
              swatchItem.addEventListener(
                'mouseleave',
                () => {
                  if (swatchItem.classList.contains('selected')) {
                    return false;
                  }
                  if (
                    swatchItem.parentNode.parentNode.querySelector(
                      '.selected[data-product-swatch]',
                    ).dataset.productCategory ==
                    swatchItem.dataset.productCategory
                  ) {
                    swatchItem.parentNode.parentNode.querySelector(
                      `[data-color-category="${swatchItem.dataset.productCategory}"] [data-product-selected]`,
                    ).textContent = swatchItem.parentNode.parentNode.querySelector(
                      '.selected[data-product-swatch]',
                    ).dataset.colorName;
                  } else {
                    swatchItem.parentNode.parentNode.querySelector(
                      `[data-color-category="${swatchItem.dataset.productCategory}"] [data-product-selected]`,
                    ).textContent = '';
                  }
                },
                false,
              );
              swatchItem.addEventListener('click', (e) => {
                e.preventDefault();
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let itemTrack = {
                  Name: swatchProduct.title,
                  ProductID: swatchProduct.id,
                  Categories: swatchProduct.categories,
                  ImageURL: swatchProduct.featuredImage,
                  URL: 'https://reef-admin.myshopify.com' + swatchProduct.url,
                  Brand: swatchProduct.vendor,
                  Price: swatchProduct.formattedPrice,
                  CompareAtPrice: swatchProduct.formattedCompareAtPrice
                    ? swatchProduct.formattedCompareAtPrice
                    : '$0.00',
                };
                if (typeof _learnq !== 'undefined') {
                  _learnq.push(['track', 'Viewed Product', itemTrack]);
                  _learnq.push([
                    'trackViewedItem',
                    {
                      Title: itemTrack.Name,
                      ItemId: itemTrack.ProductID,
                      Categories: itemTrack.Categories,
                      ImageUrl: itemTrack.ImageURL,
                      Url: itemTrack.URL,
                      Metadata: {
                        Brand: itemTrack.Brand,
                        Price: itemTrack.Price,
                        CompareAtPrice: itemTrack.CompareAtPrice,
                      },
                    },
                  ]);
                }
                mainProduct.querySelector(
                  '.variants__size--label p span',
                ).style.display = 'inline-block';
                let formButtons =
                  mainProduct.querySelectorAll('[data-product-add]');
                formButtons.forEach((button) => {
                  button.removeAttribute('data-selected-variant');
                  button.removeAttribute('data-drawer-trigger');
                  button.classList.remove('hide-add');
                  button.textContent = 'Add to Cart';
                });
                mainProduct.querySelector(
                  '.main-product__back-in-stock',
                ).style.display = 'none';
                if (history.replaceState) {
                  var newurl = `${window.location.protocol}//${window.location.host}${swatchProduct.url}`;
                  window.history.replaceState({ path: newurl }, '', newurl);
                }
                this.updatePromoMessage(swatchProduct);
                this.updateProductFeatures(swatchProduct);
                this.updateShippingInfo(swatchProduct);
                this.updateQualityInfo(swatchProduct);
                this.updateBenefits(swatchProduct);
                this.updateImages(swatchProduct);
                this.updateBadges(swatchProduct);
                this.updateMainInfo(swatchProduct);
                this.updateKlarna(swatchProduct);
                this.reviewClickHandle();
                if (window.innerWidth < 992) {
                  this.initedCarousel?.destroy();
                  this.initedCarousel = this.initCarousel(
                    document.querySelector(`.${this.type}__image`),
                  );
                }
                this.setVideoControlsHadle();
                this.mainProductItem.buildOtherSwatches(
                  swatchProduct,
                  this.type,
                );
                buildSizes(swatchProduct, swatchProduct.id, 'regular');
                this.mainProductItem.initZoom(this.type);
                this.mainProductItem.BISInit(this.type);
                variantsList
                  .querySelector('.selected[data-product-swatch]')
                  .classList.remove('selected');
                e.currentTarget.classList.add('selected');
              });
            }
          }
          let renderedBadge = this.mainProductItem.buildBadge(
            this.mainProductItem.badgeTags,
          );
          renderedBadge
            ? this.mainProductItem.el
                .querySelector(`.main-product__image--wrap`)
                .appendChild(renderedBadge)
            : null;
        }
      } else {
        if (timespend > 5000) {
          clearInterval(mainProductWait);
        }
      }
    }, 2);

    mainProduct
      .querySelector(`.${this.type}__form--wrap button`)
      .addEventListener('click', (e) => {
        this.container.querySelector(
          '.variants__size--label p span',
        ).style.visibility = 'visible';
        if (
          e.currentTarget.dataset.selectedVariant == undefined &&
          e.currentTarget.parentNode.classList.contains('sticky-add')
        ) {
          window.scroll({
            top:
              this.container.querySelector('[data-option-name="size"]')
                .offsetTop - 210,
            behavior: 'smooth',
          });
        }
      });

    this.mainProductItem.initZoom(this.type);
    this.mainProductItem.BISInit(this.type);
  },

  onLoad: function (e) {
    this.closeProductAccordions();
    this.initedCarousel = this.initCarousel(
      document.querySelector(`.${this.type}__image`),
    );
    this.initMain();
    this.stickyBuyButton();
    // this.scrollToReviews();
  },
});
